import { render, staticRenderFns } from "./realtimeCarTable.vue?vue&type=template&id=0bfadbf8&scoped=true"
import script from "./realtimeCarTable.vue?vue&type=script&lang=js"
export * from "./realtimeCarTable.vue?vue&type=script&lang=js"
import style0 from "./realtimeCarTable.vue?vue&type=style&index=0&id=0bfadbf8&prod&lang=scss&scoped=true"
import style1 from "./realtimeCarTable.vue?vue&type=style&index=1&id=0bfadbf8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfadbf8",
  null
  
)

export default component.exports